<template>
  <template v-if="error">
    <NuxtImg class="tw-w-full tw-h-full" alt="404" src="/res/img/developers/404.png" />
  </template>
  <template v-else>
    <iframe :srcdoc="iframeTemplate(iframeBody, iframeLinks)" width="100%" ref="iframe" scrolling="no"></iframe>
  </template>
</template>

<script setup lang="ts">
  import jsonp from 'jsonp'
  type IGistData = Record<'created_at' | 'description' | 'div' | 'owner' | 'stylesheet', string> & { files: Array<string>; public: boolean }

  const props = defineProps<{ gistId: string; file?: string }>()
  const iframeBody = ref<string>('')
  const iframeLinks = ref<string[]>([])
  const error = ref<boolean>(false)
  const iframe = ref<HTMLIFrameElement | null>(null)
  const time = ref<NodeJS.Timeout | null>(null)

  const getGistData = async (gistId: string, file?: string): Promise<IGistData> => {
    const params = new URLSearchParams()
    if (file) {
      params.append('file', file)
    }
    return new Promise((resolve, reject) => {
      jsonp(
        `https://gist.github.com/${gistId}.json?${params.toString()}`,
        { timeout: 20000 },
        (err, response: IGistData) => {
          if (err) {
            reject(err)
            return
          }
          resolve(response)
        },
      )
    })
  }

  const iframeTemplate = (body: string, links: string[]) => {
    return `<html>
            <head>
                <style>
                html, body {
                    margin: 0;
                    padding: 0;
                }
                </style>
                ${links.map((link) => `<link rel="stylesheet" href="${link}">`).join('\n')}
            </head>
            <body>${body}</body>
        </html>`
  }

  onMounted(async () => {
    try {
      error.value = false
      iframeBody.value = 'loading...'
      if (props.gistId) {
        const resp = await getGistData(props.gistId, props.file)
        iframeBody.value = resp.div
        iframeLinks.value = ['https://fonts.googleapis.com/icon?family=Material+Icons', resp.stylesheet]
        time.value = setTimeout(() => {
          if (iframe.value && iframe.value.contentWindow) {
            iframe.value.style.height = iframe.value.contentWindow.document.body.scrollHeight + 'px'
          }
        }, 1000)
      }
    } catch (err) {
      error.value = true
    }
  })

  onUnmounted(() => {
    if (time.value) {
      clearTimeout(time.value)
    }
  })
</script>
